export class Permission {
  constructor(permission = {}) {
    this.id = permission.id;
    this.name = permission.name;
    this.description = permission.description;
    this.key = permission.key;
  }
}
